import {
  LayoutTitle,
  FormRow,
  extendableComponent,
  IconSvg,
  iconSearch,
} from '@graphcommerce/next-ui'
import { i18n } from '@lingui/core'
import { Trans } from '@lingui/react'
import { Box, SxProps, TextField, Theme } from '@mui/material'
import { useForm } from 'react-hook-form'
import { useSearchBox, UseSearchBoxProps, useClearRefinements } from 'react-instantsearch-hooks-web'

const name = 'SearchBox' as const
const parts = ['root', 'totalProducts'] as const
const { classes } = extendableComponent(name, parts)

type SearchBoxProps = UseSearchBoxProps & { sx?: SxProps<Theme> }

export function SearchBox(props: SearchBoxProps) {
  const { sx = [] } = props
  const { query, refine } = useSearchBox()
  const { register, watch } = useForm()

  const clearRefinementApi = useClearRefinements()

  const handleSubmit = (e: React.SyntheticEvent) => e.preventDefault()
  const handleChange = () => {
    refine(watch('searchInput') as string)
    clearRefinementApi.refine()
  }

  return (
    <Box
      className={classes.root}
      component='form'
      noValidate
      onChange={handleChange}
      onSubmit={handleSubmit}
      sx={[
        (theme) => ({
          margin: `0 ${theme.spacings.xxl}`,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <LayoutTitle gutterBottom={false} gutterTop>
        {query ? i18n._(/* i18n */ 'Results for "{0}"', { 0: query }) : <Trans id='All products' />}
      </LayoutTitle>
      <FormRow>
        <TextField
          variant='outlined'
          type='text'
          placeholder={query || i18n._(/* i18n */ 'Search')}
          {...register('searchInput', {
            required: true,
            minLength: { value: 2, message: 'Required minimum is 2' },
          })}
          InputProps={{
            endAdornment: <IconSvg src={iconSearch} sx={{ color: 'text.secondary', ml: 1 }} />,
          }}
        />
      </FormRow>
    </Box>
  )
}
